import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { StorageService } from './storage.service';
import { Response } from '../interface/response';
import { HttpService } from './http.service';

@Injectable()
export class EnumService {

    constructor(
        private http: HttpService,
        private storageService: StorageService
    ) {
    }

    createStore() {
        return this.storageService.storage.createInstance({
            name: 'enuminfo'
        });
    }

    async getValue(mainKey: string, key: string) {
        let value = '';
        if (mainKey.trim() === '' || key.trim() === '') {
            return value;
        }
        await this.getList(mainKey).then(list => {
            list = list || [];
            for (let i = 0, j = list.length; i < j; i += 1) {
                if (list[i].value === key) {
                    value = list[i].label;
                    break;
                }
            }
        });
        return value;
    }

    getValueFrom(list: Array<any> = [], key: string) {
        let value = '';
        for (let i = 0, j = list.length; i < j; i += 1) {
            if (list[i].value === key) {
                value = list[i].label;
                break;
            }
        }
        return value;
    }

    async getList(mainKey: string) {
        let cache: any;
        let data: any = [];
        if (mainKey.trim() === '') {
            return data;
        }
        const store = this.createStore();
        await store.getItem(mainKey).then(value => {
            cache = value;
        });
        if (cache === null) {
            const params = new HttpParams().set('typeName', mainKey);
            await this.http.get('api/getTypeDict', { params: params }).toPromise().then(response => {
                if (response['head'].status === 1) {
                    data = response['body'];
                    store.setItem(mainKey, data);
                }
            });
            return data;
        }
        return cache;
    }

    verifyCacheVersion() {
        this.http.get('api/curDictCacheVersion', {}).toPromise().then(response => {
            if (response['head'].status === 1) {
                const CacheVersionKey = response['body'].name || 'dict_cache_version';
                try {
                    const store = this.createStore();
                    store.getItem(CacheVersionKey).then(ver => {
                        if (ver !== response['body'].version) {
                            store.clear();
                            store.setItem(CacheVersionKey, response['body'].version);
                        }
                    });
                } catch (error) {
                    console.error(error);
                }
            }
        });
    }
}



// WEBPACK FOOTER //
// F:/WMS/X-xiamenzhuhe-SDM234/zhuhe-234/sdm_fe/src/app/core/services/enum.service.ts